module.exports = __webpack_public_path__ + "static/img/totGd.1f95ab2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cockpit/totGd.png
// module id = GnQ2
// module chunks = 31